import { useState, useEffect } from "react";
import axios from "axios";

const API_KEY = process.env.REACT_APP_GIPHY_API_KEY;
const url = `https://api.giphy.com/v1/gifs/random?api_key=${API_KEY}`;

const useGif = (tag) => {
  const [gif, setGif] = useState("");
  const [loading, setLoading] = useState("false");

  async function fetchData(tag) {
    setLoading(true);
    const { data } = await axios.get(tag ? `${url}&tag=${tag}` : url);
    const imageSrc = data.data.images.downsized_large.url;
    // console.log(imageSrc);
    setGif(imageSrc);
    setLoading(false);
  }

  useEffect(() => {
    fetchData("Ronaldo");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { gif, loading, fetchData };
};

export default useGif;
